module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "verify-email-success"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('congratulations')))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('successPrivilege'))), _c('span', [_vm._v(_vm._s(_vm.$t('freeTrail')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v(_vm._s(_vm.$t('checkAccount')))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/verifyEmail/success.png",
      "alt": "Verify email success"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77e269ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/verifyEmailSuccess/VerifyEmailSuccess.vue
// module id = 1358
// module chunks = 1